import type { WalletFundProvider } from '../redux/buzzbridge/types';
import { getCurrencySymbol } from '../constants/currency';

export type BillingPaymentProvider = WalletFundProvider;

export function billingAddCardTitle(provider: BillingPaymentProvider): string {
    if (provider === 'paystack' || provider === 'flutterwave') {
        return 'Add a payment method';
    }
    return 'Add a credit card for payment';
}

export function billingAddCardSubtitle(provider: BillingPaymentProvider): string {
    if (provider === 'paystack') {
        return 'This card will be verified on Paystack and used by default for billing.';
    }
    if (provider === 'flutterwave') {
        return 'This card will be verified on Flutterwave and used by default for billing.';
    }
    return 'This credit card will be used by default for billing.';
}

export function billingAddCardButtonLabel(provider: BillingPaymentProvider): string {
    if (provider === 'paystack') return 'Add card on Paystack';
    if (provider === 'flutterwave') return 'Add card on Flutterwave';
    return 'Add new card (+)';
}

/** Footer note for hosted card-check rails. */
export function billingCardCheckNote(
    provider: BillingPaymentProvider,
    opts?: { amountMinor?: number; currency?: string },
): string | null {
    if (provider === 'paystack') {
        const major = (opts?.amountMinor ?? 5000) / 100;
        const symbol = getCurrencySymbol((opts?.currency || 'NGN').toUpperCase());
        return `When adding a new card, we initiate a small ${symbol}${major} charge to authenticate your account. This will be refunded.`;
    }
    if (provider === 'flutterwave') {
        return 'When adding a new card, Flutterwave charges a small amount to verify your card and refunds it right away.';
    }
    return null;
}
